(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ua_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.innerHeader = document.querySelector('header.header');
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerLogoWordmark = document.querySelector('.header .icon-antler-wordmark');
      this.headerlogoIcon = document.querySelector('.header .icon-antler-logo');
      this.animatedLogoEl = document.querySelector('animated-logo');
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 1200px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // check if header is at top of page on load
      this.isHeaderTop();
      // if header is set to always sticky
      if (this.headerIsAlwaysSticky) {
        // keep checking if header is at the top or not
        window.addEventListener('scroll', this.isHeaderTop.bind(this));

        // if both icons are not found return
        if(!this.headerlogoIcon || !this.headerLogoWordmark) return;

        // if header is not at top of page on load, replace icon logo with wordmark logo
        if(window.pageYOffset > 0 || document.documentElement.scrollTop > 0) {
          this.headerlogoIcon.classList.add('logo-hidden')
          this.headerLogoWordmark.classList.add('show')
        }
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('details-modal.header__search details');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    isHeaderTop() {
      if (window.pageYOffset <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
      } else {
        this.header.classList.add('shopify-section-header-sticky');
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.innerHeader.offsetHeight}px`);
      document.documentElement.style.setProperty('--header-height-for-image-banner', `${this.header.offsetHeight}px`);
      this.announcementBar ? document.documentElement.style.setProperty('--promobanner-height', `${this.announcementBar.offsetHeight}px`) : document.documentElement.style.setProperty('--promobanner-height', '0px');

    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.innerHeader);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch.hasAttribute('open')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
